import React, { useEffect, useRef, useState } from "react";
import { Button } from "../../helpers";
import { useParams } from "react-router-dom";
import { getDeliveryChallanById } from "../../services/api/deliveryChallan";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { useDispatch } from "react-redux";

// common
import Loading from "../../common/Loading";
import DOMPurify from 'dompurify';
import Parser from 'html-react-parser';

import DocumentView from "../../common/DocumentView";
import Menu from "../../helpers/Menu";
import { getDocCopyByDocNo } from "../../services/api/docCopy";
import downloadFile from "../../utils/DownloadFile";

function DeliveryChallan() {
    const { deliveryChallanId } = useParams()

    const [isPDFLoading, setIsPDFLoading] = useState(false)
    const [deliveryChallan, setDeliveryChallan] = useState({})
    const [deliveryChallanPdfUrl, setDeliveryChallanPdfUrl] = useState('')
    const [documentHTML, setDocumentHTML] = useState('')

    const actionMenu = useRef(null)

    const dispatch = useDispatch()

    useEffect(() => {
        getDeliveryChallanDetails()
    }, [deliveryChallanId])

    const getDeliveryChallanDetails = async () => {
        setIsPDFLoading(true)

        const deliveryChallanRes = await getDeliveryChallanById(deliveryChallanId)
        console.log("deliveryChallanRes", deliveryChallanRes)

        if (deliveryChallanRes?.failure){
            return dispatch(raiseToast({severity:'error', summary: 'Delivery Challan Doc', detail: deliveryChallanRes.data.error, life: 3000}))
        }

        setDeliveryChallan(deliveryChallanRes?.data?.deliveryChallan)
        setDeliveryChallanPdfUrl(deliveryChallanRes?.data?.deliveryChallanPdfUrl)
        setDocumentHTML(deliveryChallanRes?.data?.documentHTML)

        setIsPDFLoading(false)
    }

    const regenerateDocCopy = async () => {
        if(!window.confirm("Confirm to regenerate document")){
            return
        }

        setIsPDFLoading(true)

        const createNewDocCopy = true
        const docCopyRes = await getDocCopyByDocNo(deliveryChallan.docNo, null, createNewDocCopy)
        console.log("docCopyRes", docCopyRes)

        if(docCopyRes.failure){
            return dispatch(raiseToast({severity:'error', detail: docCopyRes.data.error, life: 3000}))
        }

        await getDeliveryChallanDetails()
        setIsPDFLoading(false)
    }

    const actionMenuItems = [
        {
            label: isPDFLoading ? "Loading..."  : 'Download Delivery Challan',
            command: () => {
                if(deliveryChallanPdfUrl){
                    downloadFile(deliveryChallanPdfUrl, 'deliveryChallan.pdf')
                }
                else{
                    setIsPDFLoading(true)
                    getDeliveryChallanPDFURL() 
                }
            }
        },
        {
            label: "Regenerate Document",
            className: "cancel-btn",
            command: () => regenerateDocCopy(),            
            permissions: [102],
            visible: true,
            disabled: isPDFLoading
        }
    ]

    const getDeliveryChallanPDFURL = async () => {
        const generateIfNotExists = true
        const docCopyRes = await getDocCopyByDocNo(deliveryChallan.docNo, generateIfNotExists)
        console.log(docCopyRes?.docLocation)

        if(docCopyRes.failure){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "Delivery Challan Document", detail:docCopyRes.data.error, life: 3000}))
        }
        
        if(!docCopyRes?.docLocation){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "Delivery Challan Document", detail: "Delivery Challan document was not found.", life: 3000}))
        }

        await getDeliveryChallanDetails()

        downloadFile(docCopyRes.docLocation, 'deliveryChallan.pdf')
        setIsPDFLoading(false)
    }

    const renderDeliveryChallanPDF = (deliveryChallanPdfUrl) => {
        return(
            <div className="" style={{width: '210mm'}}>
                <DocumentView fileUrl={deliveryChallanPdfUrl} />
            </div>
        )
    }

    const renderDeliveryChallanHTML = (documentHTML) => {
        const sanitizedHTML = DOMPurify.sanitize(documentHTML)
        return(
            <>
                {Parser(sanitizedHTML)}
            </>
        )
    }

    return(
        <>
            <Loading visible={isPDFLoading} />
            <div className="pb-3 document-page document-page-height" style={{ }}>
                <div className="mb-2 document-page-container" style={{ width: "" }}>
                    <div className="flex justify-content-end">
                        <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                        <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    </div>
                </div>
                <div className="document-y-scroll">
                    {
                        deliveryChallanPdfUrl ? renderDeliveryChallanPDF(deliveryChallanPdfUrl) : renderDeliveryChallanHTML(documentHTML)
                    }
                </div>
               
            </div>
        </>
    )
}

export default DeliveryChallan;